export const ADPOPCORN_PLACEMENT_IDS = {
  //* 홈 화면 상단 퀵메뉴 "혜택"
  HOME_QUICK_MENU: {
    android: '9OT0HR3hgIze',
    ios: 'q2ysL5KbViPJ',
  },
  //* 하단 네비게이션 "혜택" — 일반 화면
  BOTTOM_NAV: {
    android: 'HNgUu6TyfYX4',
    ios: 'taXej7CSQ9LT',
  },
  //* 하단 네비게이션 "혜택" — 웰마켓 화면
  BOTTOM_NAV_WELMARKET: {
    android: 'Xoxr71EFut6M',
    ios: 'IeqtJjb1t462',
  },
  //* 우측 상단 메뉴 팝오버 + 마이페이지 메뉴 "혜택"
  MY_ENTRY: {
    android: 'cNmOt5cfk5Hl',
    ios: 'YlemNwjsRiGS',
  },
} as const;

export type AdpopcornPlacementKey = keyof typeof ADPOPCORN_PLACEMENT_IDS;
